import React from 'react';

const CARD_CONFIG = {
  single: {
    icon: '✈️',
    title: 'Viaje puntual',
    description: 'Cobertura para un sólo viaje',
  },
  multiple: {
    icon: '🗓️',
    title: 'Más de un viaje al año',
    description: 'La mejor opción son los planes Multitrip anuales',
    info: 'Multitrip: viajes ilimitados por 365 días. Cada viaje hasta un máximo de 30, 60 o 90 días consecutivos cada uno',
  },
  national: {
    icon: '🏠',
    title: 'Viaje Nacional',
    description: 'Cobertura dentro de tu país',
  },
  seniors: {
    icon: '🧓',
    title: 'Adultos Mayores',
    description: 'Cobertura especial para viajeros de 86 a 99 años',
  },
};

const getCardType = (productName) => {
  const name = (productName || '').toLowerCase();
  if (name.includes('puntual')) return 'single';
  if (name.includes('nacional')) return 'national';
  if (name.includes('multiple') || name.includes('múltiple')) return 'multiple';
  if (name.includes('mayor') || name.includes('longevo') || name.includes('senior')) return 'seniors';
  return 'single';
};

const MobileInsuranceCards = ({ products, selectedInsurance, onSelect }) => {
  const activeProducts = (products || []).filter(p => p.active);
  if (activeProducts.length === 0) return null;

  return (
    <div className="sf-insurance-cards">
      <div className="sf-insurance-cards__grid">
        {activeProducts.map((product) => {
          const type = getCardType(product.name);
          const config = CARD_CONFIG[type] || CARD_CONFIG.single;
          const isSelected = selectedInsurance?.id === product.id;

          return (
            <button
              key={product.id}
              type="button"
              className={`sf-insurance-card ${isSelected ? 'sf-insurance-card--active' : ''}`}
              onClick={() => onSelect(product)}
            >
              <span className="sf-insurance-card__icon">{config.icon}</span>
              <span className="sf-insurance-card__title">{config.title}</span>
              <span className="sf-insurance-card__desc">{config.description}</span>
              {isSelected && config.info && (
                <span className="sf-insurance-card__info">{config.info}</span>
              )}
              <span className={`sf-insurance-card__cta ${isSelected ? 'sf-insurance-card__cta--selected' : ''}`}>
                {isSelected ? '✓ Seleccionado' : 'Seleccionar →'}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MobileInsuranceCards;
